import spriteMarkup from './assets/logos.svg?raw';

/**
 * The logo sprite lives in the page itself, once, and logos point at it with `#logo-<id>`.
 * Safari does not draw gradients, clip paths or masks of a symbol used from an external file
 * (`<use href="logos.svg#id">`), so multi-colour marks such as Outlook and Teams stayed empty.
 * The markup is our own bundled asset, not user input.
 */
export function mountLogoSprite(doc: Document = document): void {
  if (doc.getElementById('nv-logo-sprite')) return;
  const holder = doc.createElement('div');
  holder.id = 'nv-logo-sprite';
  holder.setAttribute('aria-hidden', 'true');
  holder.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  holder.innerHTML = spriteMarkup;
  doc.body.prepend(holder);
}
